import { render, staticRenderFns } from "./AppMenuEntry.vue?vue&type=template&id=22dcd4f7&scoped=true"
import script from "./AppMenuEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuEntry.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMenuEntry.vue?vue&type=style&index=0&id=22dcd4f7&prod&scoped=true&lang=scss"
import style1 from "./AppMenuEntry.vue?vue&type=style&index=1&id=22dcd4f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcd4f7",
  null
  
)

export default component.exports